module.exports = __webpack_public_path__ + "img/pantalla-3-3.a3764bba.png";